import { http } from '@/api/http';

/**
 * Raw transport for the non-admin feature-flag read path (PTV2-1067 §11b,
 * Phase 7) — `GET /api/v1/features` and its definitions manifest. Unlike
 * `/api/v1/configs`, these are readable by ANY authenticated user: the backend
 * only ever emits keys explicitly catalogued `exposure = AUTHENTICATED`, with
 * `visibleWhen`-gated flags silently omitted per caller (never a 403).
 *
 * Both endpoints return empty today — the flag infrastructure ships dormant
 * (no flag is catalogued yet); the shapes are exercised against synthetic
 * flags in backend tests.
 */

/** BOOL flags travel as JSON booleans; ENUM flags as their variant token. */
export type FeatureFlagValue = boolean | string | null;

/** The per-user flag map — `{}` while no flag is catalogued. */
export type FeatureFlagMapDto = Readonly<Record<string, FeatureFlagValue>>;

/** One `GET /features/manifest` row — flag metadata only, never values. */
export interface FeatureFlagManifestEntryDto {
  readonly key: string;
  /** Backend `ConfigType` name — `BOOL` or `ENUM` for flags. */
  readonly type: string;
  /** Allowed variants when `type === 'ENUM'`; otherwise `null`. */
  readonly enumValues: readonly string[] | null;
}

export const featureFlagsEndpoints = {
  getFeatureFlags: (options?: { signal?: AbortSignal }): Promise<FeatureFlagMapDto> =>
    http.get<FeatureFlagMapDto>('/features', options),
  getFeatureFlagManifest: (options?: {
    signal?: AbortSignal;
  }): Promise<FeatureFlagManifestEntryDto[]> =>
    http.get<FeatureFlagManifestEntryDto[]>('/features/manifest', options),
};
